import React from 'react'
import TextField from '@material-ui/core/TextField';
import ReactTooltip from 'react-tooltip'

const TextOption = props => (
    <div className="form-input-container">
        <b>{props.title}</b>
        <TextField
            style={{width: props.width, paddingLeft: '20px'}}
            inputProps={{
                maxLength: props.maxLength,
              }}
            label=""
            name={props.name}
            data-tip data-for={props.name}
            value={props.value}
            placeholder={props.placeholder}
            onChange={props.handleInputChange}>
        </TextField>

        <ReactTooltip id={props.name} place="right" type="light" effect="solid">
            {props.tooltip}
        </ReactTooltip>
    </div>

)
export default TextOption;
